import {
  type ProjectId,
  type ServerLifecycleWelcomePayload,
  type ThreadId,
} from "@cmmd-forge/contracts";

interface WelcomePayloadSyncDependencies {
  ensureEnvironmentConnectionBootstrapped: (
    environmentId: ServerLifecycleWelcomePayload["environment"]["environmentId"],
  ) => Promise<void>;
  isDisposed: () => boolean;
  setActiveEnvironmentId: (
    environmentId: ServerLifecycleWelcomePayload["environment"]["environmentId"],
  ) => void;
  setProjectExpanded: (
    environmentId: ServerLifecycleWelcomePayload["environment"]["environmentId"],
    projectId: ProjectId,
  ) => void;
  updateEnvironmentDescriptor: (environment: ServerLifecycleWelcomePayload["environment"]) => void;
  // Deprecated policy hook: welcome payloads must never auto-navigate to bootstrap threads.
  navigateToBootstrapThread?: (route: {
    environmentId: ServerLifecycleWelcomePayload["environment"]["environmentId"];
    threadId: ThreadId;
  }) => Promise<void>;
}

export async function syncWelcomePayloadForEventRouter(
  payload: ServerLifecycleWelcomePayload | null,
  deps: WelcomePayloadSyncDependencies,
): Promise<void> {
  if (!payload) {
    return;
  }

  deps.updateEnvironmentDescriptor(payload.environment);
  deps.setActiveEnvironmentId(payload.environment.environmentId);

  await deps.ensureEnvironmentConnectionBootstrapped(payload.environment.environmentId);
  if (deps.isDisposed()) {
    return;
  }
  if (!payload.bootstrapProjectId || !payload.bootstrapThreadId) {
    return;
  }

  deps.setProjectExpanded(payload.environment.environmentId, payload.bootstrapProjectId);
}
